import { createSlice } from '@reduxjs/toolkit';
import { t } from 'i18next';
import { showSuccess } from '../../app/utils/sweetAlert';
import { addRewardProgram, createReward, deleteReward, editReward, enrollMember, getClaimsList, getMemberCustomerList, getMembersDetails, getMembersList, getPointLogs, getRewardConfiguration, getRewardDashboardHistoric, getRewardDashboardStats, getRewardMemberCount, getRewardProductsList, getRewardProgram, getRewardsList, unEnrollMember, updateClaimStatus, updateRewardConfiguration, updateRewardProgram, updateRewardStatus, } from '../apis/rewardAPIs';
interface CategoryState {
	loading: boolean;
	error: string;
	appSetting: any;
	reasonList: any;
	claimsList: any;
	claimsCount: any;
	configData: Object;
	programList: any;
	programCount: number;
	currentPage: number;
	rewardsList: any;
	rewardProductsCount: number;
	membersCount: number;
	allMembersCount: any;
	memberCustomersCount: number;
	rewardProductsList: any;
	rewardsCount: any;
	imgBaseUrl: any;
	membersList: any;
	searchKey: string;
	memberCustomersList: any;
}
const initialState: CategoryState = {
	loading: false,
	error: '',
	appSetting: null,
	reasonList: [],
	programList: [],
	claimsList: [],
	configData: {},
	programCount: 0,
	imgBaseUrl: '',
	claimsCount: 0,
	currentPage: 1,
	rewardsCount: 0,
	membersCount: 0,
	allMembersCount: {},
	memberCustomersCount: 0,
	rewardProductsCount: 0,
	searchKey: '',
	rewardsList: [],
	membersList: [],
	memberCustomersList: [],
	rewardProductsList: []
};
const rewardSlice = createSlice({
	name: 'reward',
	initialState,
	reducers: {
		// handleFilter(state, action: any) {
		// 	state.filter = action.payload;
		// },
		handlePagination(state, action: any) {
			state.currentPage = action.payload;
		},
		handleSearchKey(state, action) {
			state.searchKey = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(getRewardConfiguration.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.configData = {};
		});
		builder.addCase(getRewardConfiguration.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.error = '';
			state.configData = action.payload;
		});
		builder.addCase(getRewardConfiguration.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(updateRewardConfiguration.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(updateRewardConfiguration.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(updateRewardConfiguration.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getRewardProgram.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.programList = [];
		});
		builder.addCase(getRewardProgram.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.programList = action.payload.list;
			state.programCount = action.payload.count;
		});
		builder.addCase(getRewardProgram.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(addRewardProgram.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(addRewardProgram.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(addRewardProgram.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateRewardProgram.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateRewardProgram.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(updateRewardProgram.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getClaimsList.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.claimsList = [];
		});
		builder.addCase(getClaimsList.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.claimsList = action.payload.list;
			state.claimsCount = action.payload.count;
		});
		builder.addCase(getClaimsList.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(updateClaimStatus.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateClaimStatus.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(updateClaimStatus.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getRewardsList.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.rewardsList = [];
		});
		builder.addCase(getRewardsList.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.rewardsList = action?.payload.list;
			state.rewardsCount = action.payload.count;
			state.imgBaseUrl = action.payload.reward_product_image_base_url;
		});
		builder.addCase(getRewardsList.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(updateRewardStatus.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(updateRewardStatus.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		});
		builder.addCase(updateRewardStatus.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(createReward.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(createReward.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(createReward.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(editReward.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(editReward.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(editReward.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(deleteReward.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(deleteReward.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(deleteReward.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getRewardProductsList.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.rewardProductsList = [];
		});
		builder.addCase(getRewardProductsList.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.rewardProductsList = action.payload.list;
			state.rewardProductsCount = action.payload.count;
		});
		builder.addCase(getRewardProductsList.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getMembersList.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.membersList = [];
		});
		builder.addCase(getMembersList.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.membersList = action?.payload.list;
			state.membersCount = action.payload.count;
		});
		builder.addCase(getMembersList.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getMemberCustomerList.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			state.memberCustomersList = [];
		});
		builder.addCase(getMemberCustomerList.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.memberCustomersList = action?.payload.list;
			state.memberCustomersCount = action.payload.count;
		});
		builder.addCase(getMemberCustomerList.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(enrollMember.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(enrollMember.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(enrollMember.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(unEnrollMember.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			showSuccess({ message: t(action.payload.message) });
		}
		);
		builder.addCase(unEnrollMember.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(unEnrollMember.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getMembersDetails.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
			// state.membersList = [];
		});
		builder.addCase(getMembersDetails.fulfilled, (state: CategoryState) => {
			state.loading = false;
			// state.membersList = action?.payload.list;
			// state.membersCount = action.payload.count;
		});
		builder.addCase(getMembersDetails.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getPointLogs.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getPointLogs.fulfilled, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getPointLogs.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getRewardDashboardStats.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getRewardDashboardStats.fulfilled, (state: CategoryState) => {//, action: any
			state.loading = false;
		});
		builder.addCase(getRewardDashboardStats.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getRewardDashboardHistoric.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getRewardDashboardHistoric.fulfilled, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getRewardDashboardHistoric.rejected, (state: CategoryState) => {
			state.loading = false;
		});
		builder.addCase(getRewardMemberCount.pending, (state: CategoryState) => {
			state.loading = true;
			state.error = '';
		});
		builder.addCase(getRewardMemberCount.fulfilled, (state: CategoryState, action: any) => {
			state.loading = false;
			state.allMembersCount = action.payload;
		});
		builder.addCase(getRewardMemberCount.rejected, (state: CategoryState) => {
			state.loading = false;
		});
	}
});
export const {
	handlePagination,
	handleSearchKey,
} = rewardSlice.actions;
export default rewardSlice.reducer;
